export function SessionLoader() {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'grid',
        placeItems: 'center',
        background: 'var(--surface, #FBF8F2)',
        color: 'var(--text-3, rgba(0,0,0,0.55))',
        fontFamily: "'Inter', system-ui, sans-serif",
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
        <span
          aria-hidden
          style={{
            width: 22,
            height: 22,
            borderRadius: '50%',
            border: '2px solid rgba(0,0,0,0.12)',
            borderTopColor: 'var(--mm-terracotta, #C84B31)',
            animation: 'session-spin 0.8s linear infinite',
          }}
        />
        <span style={{ fontSize: 12.5, letterSpacing: '0.04em' }}>Verifying session…</span>
      </div>
      <style>{`
        @keyframes session-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}
